import {
  CalendarTwoTone,
  CloudTwoTone,
  ContactsTwoTone,
  DashboardTwoTone,
  DatabaseTwoTone,
  FileTextTwoTone,
  GiftTwoTone,
  InteractionTwoTone,
  LockTwoTone,
  MailTwoTone,
  MoneyCollectTwoTone,
  ReconciliationTwoTone,
  SettingTwoTone,
  ShopTwoTone,
  TagsTwoTone,
} from '@ant-design/icons'
import { ReactNode } from 'react'

import { ROUTES } from 'routes'

import { FEATURE } from './feature'

export const MENU_KEY = {
  DASHBOARD: '1',
  STAKING: '2',
  P2P: '3',
  PTO: '4',
  MARKET_PLACE: '5',
  AFFILIATES: '6',
  AIRDROP: '7',
  VESTING_CLAIM: '8',
  EMAIL: '9',
  USER: '10',
  TRANSACTION_HISTORY: '11',
  SETTING: '12',
  USER_ADMIN: '13',
  PORTAL: '14',
  HMC_FUND_INCENTIVE: '15',
  VENTURE_FUND_INCENTIVE: '16',
  HMC_FUND_INCENTIVE_V2: '32',
  VENTURE_FUND_INCENTIVE_V2: '33',
  STAKING_NFT: '17',
  STAKING_TOKEN: '18',
  STAKING_SUB_MENU: '19',
  VESTING_SUB_MENU: '20',
  BANNER: '21',
  SETTING_SUB_MENU: '22',
  ACCOUNT_VESTING_DATA: '23',
  ACCOUNT_VESTING_HMC: '24',
  ACCOUNT_VESTING_VENTURE: '25',
  ACCOUNT_VESTING_HMC_V2: '34',
  ACCOUNT_VESTING_VENTURE_V2: '35',
  USER_SUB_MENU: '26',
  USER_MEY_FI: '27',
  USER_MEY_REAL: '28',
  PTO_REWARDS: '29',
  PTO_SUB_MENU: '30',
  EMAIL_SUB_MENU: '36',
  EMAIL_V2: '37',
  PTO_REFERRAL: '38',
  PROPERTY_ACTIVITIES: '39',
  STAKING_TOKEN_CONFIG: '40',
  BOOSTER_PROGRAM: '41',
  PROMO_CODE: '42',
  PTO_V2: '43',
  DAO_VOTING: '44',
  PTO_V3: '45',
  STAKING_ERC3643: '46',
  WHATS_NEW: '47',
  FAQ: '48',
}

export interface SidebarMenuItem {
  value: string
  label: string
  link?: string
  /** Permission gate. Item visible only if current user can view this feature. */
  feature?: FEATURE
  /** Always visible for any authenticated admin (overrides `feature`). */
  applyAll?: boolean
  isShow?: boolean
  icon?: ReactNode
  children?: SidebarMenuItem[]
}

export const SIDEBAR_MENU: SidebarMenuItem[] = [
  {
    value: MENU_KEY.DASHBOARD,
    label: 'Dashboard',
    link: ROUTES.DASHBOARD,
    applyAll: true,
    isShow: true,
    icon: <DashboardTwoTone />,
  },
  {
    value: MENU_KEY.STAKING_SUB_MENU,
    label: 'Staking',
    icon: <MoneyCollectTwoTone />,
    isShow: true,
    children: [
      {
        value: MENU_KEY.STAKING,
        label: 'Staking',
        link: ROUTES.STAKING,
        feature: FEATURE.STAKING_POOL,
        isShow: true,
        children: [
          {
            value: MENU_KEY.STAKING,
            label: 'Staking Detail',
            link: ROUTES.STAKING_DETAIL,
            feature: FEATURE.STAKING_POOL,
          },
        ],
      },
      {
        value: MENU_KEY.STAKING_TOKEN,
        label: 'Staking Token',
        link: ROUTES.STAKING_TOKEN,
        feature: FEATURE.STAKING_TOKEN,
        isShow: true,
      },
      {
        value: MENU_KEY.STAKING_NFT,
        label: 'Staking NFT',
        link: ROUTES.STAKING_NFT,
        feature: FEATURE.STAKING_NFT,
        isShow: true,
      },
      {
        value: MENU_KEY.STAKING_ERC3643,
        label: 'Staking ERC-3643',
        link: ROUTES.STAKING_ERC3643,
        feature: FEATURE.STAKING_NFT,
        isShow: true,
      },
    ],
  },
  {
    value: MENU_KEY.P2P,
    label: 'P2P lending',
    link: ROUTES.P2P_LENDING,
    feature: FEATURE.P2P_LENDING,
    isShow: true,
    icon: <MailTwoTone />,
  },
  {
    icon: <CalendarTwoTone />,
    value: MENU_KEY.PTO_SUB_MENU,
    label: 'PTO',
    isShow: true,
    children: [
      {
        value: MENU_KEY.PTO,
        label: 'PTO',
        link: ROUTES.PTO,
        feature: FEATURE.PTO,
        isShow: true,
      },
      {
        value: MENU_KEY.PTO_V2,
        label: 'PTO v2',
        link: ROUTES.PTO_V2,
        feature: FEATURE.PTO,
        isShow: true,
      },
      {
        value: MENU_KEY.PTO_V3,
        label: 'PTO ERC-3643',
        link: ROUTES.PTO_V3,
        feature: FEATURE.PTO,
        isShow: true,
      },
      {
        value: MENU_KEY.PTO_REWARDS,
        label: 'Rewards Management',
        link: ROUTES.PTO_REWARDS,
        feature: FEATURE.PTO_REWARDS,
        isShow: true,
      },
      {
        value: MENU_KEY.PROPERTY_ACTIVITIES,
        label: 'Property Activities',
        link: ROUTES.PROPERTY_ACTIVITIES,
        feature: FEATURE.PROPERTY_ACTIVITIES,
        isShow: true,
      },
      {
        value: MENU_KEY.PTO_REFERRAL,
        label: 'Referral Program',
        link: ROUTES.PTO_REFERRAL,
        feature: FEATURE.PTO_REFERRAL,
        isShow: true,
      },
      {
        value: MENU_KEY.BOOSTER_PROGRAM,
        label: 'Booster Program',
        link: ROUTES.BOOSTER_PROGRAM,
        feature: FEATURE.BOOSTER_PROGRAM,
        isShow: true,
      },
      {
        value: MENU_KEY.DAO_VOTING,
        label: 'DAO Voting',
        link: ROUTES.DAO_VOTING,
        feature: FEATURE.DAO,
        isShow: true,
      },
    ],
  },
  {
    value: MENU_KEY.PROMO_CODE,
    label: 'Promo Code',
    link: ROUTES.PROMO_CODE,
    feature: FEATURE.PROMO_CODE,
    isShow: true,
    icon: <TagsTwoTone />,
  },
  {
    value: MENU_KEY.MARKET_PLACE,
    label: 'Marketplace',
    link: ROUTES.MARKETPLACE,
    feature: FEATURE.MARKETPLACE,
    isShow: true,
    icon: <ShopTwoTone />,
  },
  {
    value: MENU_KEY.AFFILIATES,
    label: 'Affiliates',
    link: ROUTES.AFFILIATES,
    feature: FEATURE.AFFILIATE,
    isShow: true,
    icon: <ReconciliationTwoTone />,
  },
  {
    value: MENU_KEY.AIRDROP,
    label: 'Airdrop',
    link: ROUTES.AIRDROP,
    feature: FEATURE.AIRDROP,
    isShow: true,
    icon: <CloudTwoTone />,
  },
  {
    value: MENU_KEY.VESTING_SUB_MENU,
    label: 'Vesting',
    isShow: true,
    icon: <GiftTwoTone />,
    children: [
      {
        value: MENU_KEY.VESTING_CLAIM,
        label: 'Vesting claim (2019-2022)',
        link: ROUTES.VESTING,
        feature: FEATURE.VESTING,
        isShow: true,
      },
      {
        value: MENU_KEY.HMC_FUND_INCENTIVE,
        label: 'HMC Fund Incentive',
        link: ROUTES.VESTING_HMC,
        feature: FEATURE.VESTING,
        isShow: true,
      },
      {
        value: MENU_KEY.VENTURE_FUND_INCENTIVE,
        label: 'Venture Fund Incentive',
        link: ROUTES.VESTING_VENTURE,
        feature: FEATURE.VESTING,
        isShow: true,
      },
      {
        value: MENU_KEY.HMC_FUND_INCENTIVE_V2,
        label: 'HMC Fund Incentive V2',
        link: ROUTES.VESTING_HMC_V2,
        feature: FEATURE.VESTING,
        isShow: true,
      },
      {
        value: MENU_KEY.VENTURE_FUND_INCENTIVE_V2,
        label: 'Venture Fund Incentive V2',
        link: ROUTES.VESTING_VENTURE_V2,
        feature: FEATURE.VESTING,
        isShow: true,
      },
    ],
  },
  {
    value: MENU_KEY.ACCOUNT_VESTING_DATA,
    label: 'Account Vesting',
    isShow: true,
    icon: <DatabaseTwoTone />,
    children: [
      {
        value: MENU_KEY.ACCOUNT_VESTING_HMC,
        label: 'Account Vesting HMC',
        link: ROUTES.ACCOUNT_VESTING_HMC,
        feature: FEATURE.ACCOUNT_VESTING,
        isShow: true,
      },
      {
        value: MENU_KEY.ACCOUNT_VESTING_VENTURE,
        label: 'Account Vesting Venture',
        link: ROUTES.ACCOUNT_VESTING_VENTURE,
        feature: FEATURE.ACCOUNT_VESTING,
        isShow: true,
      },
      {
        value: MENU_KEY.ACCOUNT_VESTING_HMC_V2,
        label: 'Account Vesting HMC V2',
        link: ROUTES.ACCOUNT_VESTING_HMC_V2,
        feature: FEATURE.ACCOUNT_VESTING,
        isShow: true,
      },
      {
        value: MENU_KEY.ACCOUNT_VESTING_VENTURE_V2,
        label: 'Account Vesting Venture V2',
        link: ROUTES.ACCOUNT_VESTING_VENTURE_V2,
        feature: FEATURE.ACCOUNT_VESTING,
        isShow: true,
      },
    ],
  },
  {
    value: MENU_KEY.EMAIL_SUB_MENU,
    label: 'Email',
    isShow: true,
    icon: <MailTwoTone />,
    children: [
      {
        value: MENU_KEY.EMAIL,
        label: 'Email',
        link: ROUTES.EMAIL,
        feature: FEATURE.EMAIL,
        isShow: true,
      },
      {
        value: MENU_KEY.EMAIL_V2,
        label: 'Email V2',
        link: ROUTES.EMAIL_V2,
        feature: FEATURE.EMAIL,
        isShow: true,
      },
    ],
  },
  {
    value: MENU_KEY.USER_SUB_MENU,
    label: 'User',
    isShow: true,
    icon: <ContactsTwoTone />,
    children: [
      {
        value: MENU_KEY.USER_MEY_FI,
        label: 'User (Mey FI)',
        link: ROUTES.USER,
        feature: FEATURE.USER_MEY_FI,
        isShow: true,
      },
      {
        value: MENU_KEY.USER_MEY_REAL,
        label: 'User (Mey Real)',
        link: ROUTES.USER_MEY_REAL,
        feature: FEATURE.USER_MEY_REAL,
        isShow: true,
      },
    ],
  },
  {
    value: MENU_KEY.TRANSACTION_HISTORY,
    label: 'Transaction History',
    link: ROUTES.TRANSACTION_HISTORY,
    feature: FEATURE.TRANSACTION_HISTORY,
    isShow: true,
    icon: <InteractionTwoTone />,
  },
  {
    value: MENU_KEY.SETTING_SUB_MENU,
    label: 'Setting',
    isShow: true,
    icon: <SettingTwoTone />,
    children: [
      {
        value: MENU_KEY.SETTING,
        label: 'Setting',
        link: ROUTES.SETTING,
        feature: FEATURE.SETTING,
        isShow: true,
      },
      {
        value: MENU_KEY.STAKING_TOKEN_CONFIG,
        label: 'Staking Token Config',
        link: ROUTES.STAKING_TOKEN_CONFIG,
        feature: FEATURE.SETTING,
        isShow: true,
      },
      {
        value: MENU_KEY.BANNER,
        label: 'Banner',
        link: ROUTES.BANNER,
        feature: FEATURE.BANNER,
        isShow: true,
      },
      {
        value: MENU_KEY.WHATS_NEW,
        label: "What's New",
        link: ROUTES.WHATS_NEW,
        feature: FEATURE.WHATS_NEW_VIEW,
        isShow: true,
      },
      {
        value: MENU_KEY.FAQ,
        label: 'FAQ',
        link: ROUTES.FAQ,
        feature: FEATURE.FAQ_VIEW,
        isShow: true,
      },
    ],
  },
  {
    value: MENU_KEY.USER_ADMIN,
    label: 'Administrator',
    link: ROUTES.USER_ADMIN,
    feature: FEATURE.ADMIN_MANAGEMENT,
    isShow: true,
    icon: <LockTwoTone />,
  },
  {
    value: MENU_KEY.PORTAL,
    label: 'Portal Tokenize',
    link: ROUTES.PORTAL,
    feature: FEATURE.PORTAL_TOKENIZE,
    isShow: true,
    icon: <FileTextTwoTone />,
  },
]
